export default thematics =>
  thematics.reduce((acc, thematic) => {
    acc[thematic.label] = [
      ...(acc[thematic.label] || []),
      ...thematic.questions
    ];

    return acc;
  }, {});
